const YOUTUBE_SHORTS_BASE_URL = "https://youtube.com/shorts";
const YOUTUBE_WATCH_BASE_URL = "https://youtube.com/watch";
/**
 * YouTube Shorts cannot be embedded directly but we can embed them as a normal
 * video. This function takes a shorts URL and generates the standard video URL
 *
 * Remove this hack once YouTube allows embedding shorts and React Player
 * supports it.
 *
 * https://github.com/cookpete/react-player/issues/1427
 */
export function youtubeShortsHack(youtuebUrl) {
    if (youtuebUrl.startsWith(YOUTUBE_SHORTS_BASE_URL)) {
        return youtuebUrl.replace(YOUTUBE_SHORTS_BASE_URL, YOUTUBE_WATCH_BASE_URL);
    }
    return youtuebUrl;
}
export function isYouTube(url) {
    return (url.startsWith("https://www.youtube") ||
        url.startsWith("https://youtube.com") ||
        url.startsWith("https://youtu.be"));
}
export function createYouTubeImageUrls(youtubeUri) {
    const videoId = extractYoutubeVideoId(youtubeUri);
    if (videoId) {
        return [
            /* Try all the highest quality images available */
            `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
            `https://img.youtube.com/vi/${videoId}/maxres1.jpg`,
            `https://img.youtube.com/vi/${videoId}/maxres2.jpg`,
            `https://img.youtube.com/vi/${videoId}/maxres3.jpg`,
            `https://img.youtube.com/vi/${videoId}/maxres4.jpg`,
            `https://img.youtube.com/vi/${videoId}/maxresdefault_live.jpg`,
            `https://img.youtube.com/vi/${videoId}/maxres1_live.jpg`,
            `https://img.youtube.com/vi/${videoId}/maxres2_live.jpg`,
            `https://img.youtube.com/vi/${videoId}/maxres3_live.jpg`,
            `https://img.youtube.com/vi/${videoId}/maxres4_live.jpg`,
            /* Fallback to lower res options */
            `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
            `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`,
            `https://img.youtube.com/vi/${videoId}/sddefault.jpg`,
            `https://img.youtube.com/vi/${videoId}/default.jpg`
        ];
    }
    return [];
}
export function extractYoutubeVideoId(href) {
    const url = new URL(href);
    if (url.hostname === "youtu.be") {
        return url.pathname.replace("/", "");
    }
    else if (url.searchParams.has("v")) {
        return url.searchParams.get("v");
    }
    else {
        const re = /^\/(watch|shorts)\/([^/]+)/;
        const match = re.exec(url.pathname);
        if (match) {
            return match[2];
        }
        else {
            console.warn("couldn't extract video id from URL: ", href);
            return null;
        }
    }
}
